import { useContext } from 'react';
import { ApprovalsContext } from '../Approvals.provider';

export function useSuccessSnackBar() {
  const { showSuccessSnackBar, setShowSuccessSnackBar } =
    useContext(ApprovalsContext);

  const closeSuccessSnackBar = () => {
    setShowSuccessSnackBar(false);
  };

  return { showSuccessSnackBar, closeSuccessSnackBar };
}

export function useErrorSnackBar() {
  const {
    showErrorSnackBar,
    setShowErrorSnackBar,
    errorMessage,
    setErrorMessage,
  } = useContext(ApprovalsContext);

  const closeErrorSnackBar = () => {
    setErrorMessage('');
    setShowErrorSnackBar(false);
  };

  return {
    showErrorSnackBar,
    closeErrorSnackBar,
    errorMessage,
    setErrorMessage,
  };
}
